<template>
	<el-dialog
	:title="title"
	:visible.sync="visible"
	:close-on-click-modal="false"
	width="50%"
	@close="close"
	:before-close="befclose" append-to-body>
		<el-form ref="formId" :rules="rules" :model="saveDeviceFrom" class="bm bm-ver form-info" label-position="right" size="small" label-width="90px">
			<div class="bm bm-ver">
                <div>
                    <el-row :gutter="10" class="bm bm-f1 bm-ac dept-info">
                        <el-col :span="24" class="bm bm-ps bm-ac">
                            <!-- <el-form-item label="设备大类" style="width:100%" prop="assetsKindName" 
                                :rules="{required: true, message: '请选择',trigger: 'change'}">
                                <el-select style="width:100%" filterable placeholder="请选择" @change='kindChange' v-model="saveDeviceFrom.assetsKindName" clearable size="small">
                                    <el-option v-for="item in assetsKindList" :key="item.assetsKindName" :label="item.assetsKindName" :value="item.assetsKindName"></el-option>
                                </el-select>
                            </el-form-item> -->
							 <el-form-item label="设备大类" style="width:100%" prop="assetsKindCode" 
                                :rules="{required: true, message: '请选择',trigger: 'change'}">
								<el-select style="width:100%" filterable placeholder="请选择" @change='kindChange' v-model="saveDeviceFrom.assetsKindCode" clearable size="small">
                                    <el-option v-for="(item, index) in assetsKindList" :key="index" :label="item.assetsKindName" :value="item.assetsKindCode"></el-option>
                                </el-select>
							</el-form-item>	
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" class="bm bm-f1 bm-ac dept-info">
                        <el-col :span="24" class="bm bm-ps bm-ac">
							<el-form-item label="设备中类" style="width:100%" prop="assetsTypeCode" 
                                :rules="{required: true, message: '请选择',trigger: 'change'}">
								<el-select style="width:100%" filterable placeholder="请选择" @change='typeChange'  v-model="saveDeviceFrom.assetsTypeCode" clearable size="small">
                                    <el-option v-for="(item, index) in assetsTypeList" :key="index" :label="item.name" :value="item.id" ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
					<el-row :gutter="10" class="bm bm-f1 bm-ac dept-info">
                        <el-col :span="24" class="bm bm-ps bm-ac">
							<el-form-item label="设备小类" style="width:100%" prop="assetsTypeCode" 
                                :rules="{required: true, message: '请选择',trigger: 'change'}">
								<el-select style="width:100%" filterable placeholder="请选择" v-model="saveDeviceFrom.assetsSubTypeCode" clearable size="small">
                                    <el-option v-for="(item, index) in assetsSubTypeList" :key="index" :label="item.name" :value="item.id" ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" class="bm bm-f1 bm-ac dept-info">
                        <el-col :span="24" class="bm bm-ps bm-ac">
                            <el-form-item label="设备名称" style="width:100%" prop="deviceName" 
                                :rules="{required: true, message: '请输入',trigger: 'change'}">
                                <el-input v-model="saveDeviceFrom.deviceName" size="small" clearable placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" class="bm bm-f1 bm-ac dept-info">
                        <el-col :span="24" class="bm bm-ps bm-ac">
                            <el-form-item label="设备型号" style="width:100%" prop="deviceModel" >
                                <el-input v-model="saveDeviceFrom.deviceModel" size="small" clearable placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
					<el-row :gutter="10" class="bm bm-f1 bm-ac dept-info">
                        <el-col :span="24" class="bm bm-ps bm-ac">
                            <el-form-item label="单位" style="width:100%" prop="baseMeasureUnit" 
                                :rules="{required: true, message: '请选择',trigger: 'change'}">
								<el-select style="width:100%" filterable placeholder="请选择" v-model="saveDeviceFrom.baseMeasureUnit" clearable size="small">
                                    <el-option v-for="(item, index) in baseMeasureUnitList" :key="index" :label="item.name" :value="item.name" ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
					<el-row :gutter="10" class="bm bm-f1 bm-ac dept-info">
                        <el-col :span="24" class="bm bm-ps bm-ac">
                            <el-form-item label="参考价" style="width:100%" prop="referencePrice" 
                                :rules="{required: true, message: '请输入预估单价（元）',trigger: 'change'}">
                                <el-input v-model="saveDeviceFrom.referencePrice" type="number" size="small" clearable placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>			
			</div>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="temporaryData('0')">取 消</el-button>
			<el-button type="primary" @click="temporaryData('1')" :disabled="isDisable">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
// const R = require('ramda');
import { deviceApi } from "@/services";
export default {
	name:"add-new-device",
	props: {
		
		visible: {
			type: Boolean,
			required: true
		},
		title: {
			type: String,
			default: "新增设备"
		},

	},
	data() {
		return {
			isDisable:false,
			//校验规则
            rules: {
			},
			assetsKindList: this.$store.state.init.configInfo.deviceKindInfoList,
			assetsTypeList: [],
			assetsSubTypeList:[],
			baseMeasureUnitList:this.$store.state.init.crmInit.productDictionary.baseMeasureUnitList, //单位
			saveDeviceFrom:{
				id:"",
				requestDepartCode:"",
				requestDepartName:"",
				managerName:this.$store.state.init.initData.fillPersonName,//姓名
				managerCode:this.$store.state.init.initData.fillPersonCode,//工号
				deviceCode:"",
				deviceName:"",
				assetsKindCode:"", // 设备大类编码
				assetsTypeCode:"",// 设备中类编码
				assetsSubTypeCode:"",// 设备中类编码
				deviceModel:"",// 设备型号
				arrivalDate:"",
				drivingFactor:"",
				projectName:"",
				projectCode:"",
				quantity:"",
				// price:"", //预计价格
				amount:"",
				baseMeasureUnit:"",
				referencePrice:"",
			}
		}
	},
	methods:{
		checkDept(rule, value, callback){
			let info = "";
			if (R.isNil(value) || R.isEmpty(value) || value.length == 0) {
				info="请选择部门"
				return callback(new Error(info));
			} else {
				return callback();
			}
		},
		// 大类联动
		kindChange(e){
			this.assetsTypeList = this.assetsKindList.find(item => item.assetsKindCode == e).assetsTypeList
			this.saveDeviceFrom.assetsTypeName="";
			this.saveDeviceFrom.assetsTypeCode="";
			this.saveDeviceFrom.assetsSubTypeCode="";
			this.saveDeviceFrom.assetsSubTypeName="";
		},
		typeChange(e){
			this.assetsSubTypeList = this.assetsTypeList.find(item => item.id == e).assetsSubTypeList
			this.saveDeviceFrom.assetsSubTypeCode="";
			this.saveDeviceFrom.assetsSubTypeName="";
		},
		// 取消确定按钮
		temporaryData(e){
			// 1： 确定
            if(e=='1'){
				this.saveAddDevices();
            }else{
				this.$emit('newDeviceCancel');
				this.saveDeviceFrom.assetsKindCode="";
				this.saveDeviceFrom.assetsTypeCode="";
				this.saveDeviceFrom.deviceName="";
				this.saveDeviceFrom.deviceModel="";
			}
		},
		handleChange(value) {
			// console.log(value);
		},
		close(){
			this.$refs["formId"].resetFields();
		},
		befclose(){
			this.$emit("newDeviceCancel");
			// this.visible =false;
		},
		delDeviceRow(e){
			this.saveDeviceFrom.list.splice(e,1);
		},
		// 保存设备
		saveAddDevices(){
			this.$refs["formId"].validate((valid) => {
				if (valid) {
					this.isDisable = true;
					let { deviceName, deviceModel, assetsKindCode, assetsTypeCode,assetsSubTypeCode,baseMeasureUnit,referencePrice } = this.saveDeviceFrom
					this.saveDevicesParams = {
						createUserId: this.$store.state.user.userInfo.personId,
						deviceName,
						assetsKindName: this.assetsKindList.find(item => item.assetsKindCode === assetsKindCode).assetsKindName,
						assetsTypeName: this.assetsTypeList.find(item => item.id === assetsTypeCode).name,
						assetsSubTypeName: this.assetsSubTypeList.find(item => item.id === assetsSubTypeCode).name,
						deviceModel,
						assetsKindCode, // v2.0 大类编码
						assetsTypeCode, // v2.0 中类编码
						assetsSubTypeCode,// v3.0 小类编码
						baseMeasureUnit,
						referencePrice,
					};
					deviceApi.saveAddDevices(this.saveDevicesParams).then((res)=>{
						res.responseData.id="";//20200824 新增时候id 不需要llt
						this.saveDeviceFrom.deviceCode = res.responseData;
						this.$emit("newDeviceConfirm",this.saveDeviceFrom);
						console.log("保存设备",res);
						this.isDisable=false;
					});	
					setTimeout(function(){
						this.isDisable=false;
					},2000);
				} else {
					return false;
				}
			});


		}
	},
	watch:{
		visible:{//深度监听，可监听到对象、数组的变化
			handler(val, oldVal){
				if(val){
					this.saveDeviceFrom.assetsKindName="";
					this.saveDeviceFrom.assetsTypeName="";
					this.saveDeviceFrom.deviceName="";
					this.saveDeviceFrom.deviceModel="";
					this.saveDeviceFrom.deviceCode="";
					this.saveDeviceFrom.assetsSubTypeName="";
					this.saveDeviceFrom.assetsSubTypeCode = ""
					this.saveDeviceFrom.baseMeasureUnit="";
					this.saveDeviceFrom.referencePrice="";
					
				}	
			},
			deep:true
		},
	},
	mounted(){
		
	}
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
	/deep/.el-dialog__body {
		padding: 20px 20px;
		display: flex;
		align-items: center;
		height: 50%;
    	overflow: auto;
		.form-info{
			height: 100%;
			width: 100%;
			.dept-info{
                height: 45px;
                margin-bottom: 10px;
				.futurePrice{
                    position: relative;
                    .unit{
                        z-index: 100;
                        position: absolute;
                        top: 8px;
                        right: 40px;
                        font-size: 14px;
                        color: #969696;
                    }
                }
            }
			.device-list{
				.device-list-row {
					margin-top: 30px;
				}
				.device-list-row:first-child{
					margin-top: 0px;
				}
			}
			.device-title{
				margin-left: 20px;
				margin-bottom: 10px;
				font-size: 16px;
				line-height: 16px;
				color: #323232;
				.device-model{
					font-size: 12px;
					color: #969696;
					margin-left: 9px;
					line-height: 12px;
				}
			}
			.add-device{
				margin-left: 20px;
				margin-top: 20px;
				font-size: 14px;
				line-height: 14px;
				color: #409eff;
			}
			.device-info-row{
				border: solid 1px #dcdfe5;
				padding: 20px 20px 2px 20px;
				.price{
					font-size: 14px;
					line-height: 14px;
					color: #ff3507;
					margin-left: 30px;
				}
				.del-btn{
					height: 50px;
				}
			}
			.el-input--small .el-input__inner{
				height: 36px;
				line-height: 36px;
			}
			.el-input-number__increase, .el-input-number__decrease{
				top: 2px;
				height: 28px;
			}
		}
		
	}
}
</style>
